import { Card, Separator } from '@repo/shadcn';

import { SectionError } from '@components/ui/error';
import { SectionLoader } from '@components/ui/loader';

import { HeaderBreadcrumb } from '@/components/ui';
import { Route } from '@/constants';
import { useProfitAndLossReport } from '@/modules/reports/profit-and-loss/profit-loss.hook';
import { formatCurrencyInBDT } from '@/utils';

export const ReportProfitAndLoss = () => {
    const { error, data, isError, isLoading, isFetching } =
        useProfitAndLossReport();

    if (isLoading || isFetching) {
        return <SectionLoader />;
    }

    if (isError) {
        return <SectionError error={error} fallbackPath={Route.DASHBOARD} />;
    }

    return (
        <Card className={'space-y-4 p-4'}>
            <HeaderBreadcrumb
                showHomeLink={true}
                items={[{ label: 'Reports' }, { label: 'Profit and Loss' }]}
            />

            <h2 className={'text-xl font-medium'}>Account Summary</h2>

            <div className={'font-xl mt-4 grid grid-cols-1  font-medium'}>
                <div className={'grid grid-cols-2 bg-gray-50 p-2'}>
                    <span>COGS</span>
                    <span className={'block text-right'}>
                        {formatCurrencyInBDT(data?.data?.cogs)}
                    </span>
                </div>

                <Separator />

                <div className={'grid grid-cols-2 bg-white p-2'}>
                    <span>Total Sales Revenue</span>
                    <span className={'block text-right'}>
                        {formatCurrencyInBDT(data?.data?.total_sales_revenue)}
                    </span>
                </div>

                <Separator />

                <div className={'grid grid-cols-2 bg-gray-50 p-2'}>
                    <span>Gross Profit</span>
                    <span className={'block text-right'}>
                        {formatCurrencyInBDT(data?.data?.gross_profit)}
                    </span>
                </div>

                <Separator />

                <div className={'grid grid-cols-2 bg-white p-2'}>
                    <span>Net Profit</span>
                    <span className={'block text-right'}>
                        {formatCurrencyInBDT(data?.data?.net_profit)}
                    </span>
                </div>

                <Separator />

                <div className={'grid grid-cols-2 bg-gray-50 p-2'}>
                    <span>Account Receivable</span>
                    <span className={'block text-right'}>
                        {formatCurrencyInBDT(data?.data?.account_receivables)}
                    </span>
                </div>

                <Separator />

                <div className={'grid grid-cols-2 bg-white p-2'}>
                    <span>Account Payable</span>
                    <span className={'block text-right'}>
                        {formatCurrencyInBDT(data?.data?.account_payables)}
                    </span>
                </div>
            </div>
        </Card>
    );
};

ReportProfitAndLoss.displayName = 'ReportProfitAndLoss';
